export enum NotificationType {
  NEWLY_CREATED_PURCHASE_EXISTS = 'NEWLY_CREATED_PURCHASE_EXISTS',
  APPROVAL_REQUIRED_PROCESS_EXISTS = 'APPROVAL_REQUIRED_PROCESS_EXISTS',
  APPROVED_PROCESS_EXISTS = 'APPROVED_PROCESS_EXISTS',
  REJECTED_PROCESS_EXISTS = 'REJECTED_PROCESS_EXISTS',
  DELAYED_PROCESS = 'DELAYED_PROCESS',
  ITEM_CHANGED = 'ITEM_CHANGED',
  ERP_ORDER_NOT_FOUND = 'ERP_ORDER_NOT_FOUND'
}
